import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import MosqueCreateForm from '../components/mosques/MosqueCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';

const MosqueCreatePage = () => {
  const { societySlug } = useParams();

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>Add Mosque - PakPoints</title>
        <meta name="description" content="Add a mosque to your society" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societySlug ? (
          <SocietyContextMobileNav societySlug={societySlug} activeSection="mosques" />
        ) : null}
        <div className="py-8">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <MosqueCreateForm societySlug={societySlug} />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MosqueCreatePage;
